import connectionProxy from './connectionProxy'

export const addCabinet = ({ areaId, name }) => {
  return connectionProxy.http.post(`/areas/${areaId}/armarios`, {
    name
  })
}

export const updateCabinet = ({ areaId, id, name }) => {
  return connectionProxy.http.put(`/areas/${areaId}/armarios/${id}`, {
    name
  })
}

export const removeCabinet = ({ areaId, cabinetId }) => {
  return connectionProxy.http.delete(`/areas/${areaId}/armarios/${cabinetId}`)
}

export const getCabinets = areaId => {
  return connectionProxy.http.get(`/areas/${areaId}/armarios`)
}

export const searchCabinetProduct = ({ areaId, term, cabinetId }) => {
  return connectionProxy.http.get(`/areas/${areaId}/armarios/${cabinetId}/produtos/buscar`, {
    params: {
      term
    }
  })
}

export const addCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return connectionProxy.http.post(`/areas/${areaId}/armarios/${cabinetId}/produtos`, {
    product_id: productId
  })
}

export const removeCabinetProduct = ({ areaId, productId, cabinetId }) => {
  return connectionProxy.http.delete(
    `/areas/${areaId}/armarios/${cabinetId}/produtos/${productId}`,
    {
      product_id: productId
    }
  )
}

export const downloadPdf = (areaId, cabinetId) =>
  connectionProxy.http.get(`/armarios/${cabinetId}/download_pdf`, { responseType: 'arraybuffer' })

export const getQrCode = (id) =>
  connectionProxy.http.get(`/armarios/${id}/qr_code`, { responseType: 'arraybuffer' })

// ---- matriz de incompatibilidade (grade produto x produto)

const gridUrl = ({ areaId, cabinetId }) =>
  cabinetId
    ? `/areas/${areaId}/armarios/${cabinetId}/matriz_de_incompatibilidade`
    : `/areas/${areaId}/matriz_de_incompatibilidade`

// O timeout global do connectionProxy e de 10s. A grade pode demorar mais: o custo da
// query nao e proporcional ao numero de produtos, e sim aos atributos compartilhados
// entre eles. O timeout per-request sobrescreve o global sem afetar o resto do app.
export const getIncompatibilityGrid = scope =>
  connectionProxy.http.get(gridUrl(scope), { timeout: 60000 })

// `product_ids` recorta o escopo do relatorio. A tela nao envia mais (a busca saiu do
// modal), mas o parametro continua valendo na API para exportar um subconjunto.
const downloadParams = scope =>
  scope.productIds && scope.productIds.length ? { product_ids: scope.productIds } : {}

// `pageSize`: papel do PDF ('A4' ou 'A0')
export const downloadIncompatibilityGridPdf = (scope, pageSize) =>
  connectionProxy.http.get(`${gridUrl(scope)}/download_pdf`, {
    params: { ...downloadParams(scope), page_size: pageSize },
    responseType: 'arraybuffer',
    timeout: 120000
  })

// O Excel e o formato que aguenta os escopos grandes: no PDF, 260 produtos viram 260
// colunas numa folha A4. Dai o timeout ser o mesmo, generoso.
export const downloadIncompatibilityGridXlsx = scope =>
  connectionProxy.http.get(`${gridUrl(scope)}/download_xlsx`, {
    params: downloadParams(scope),
    responseType: 'arraybuffer',
    timeout: 120000
  })



// WEBPACK FOOTER //
// ./src/api/incompatibilityAnalysis.js